import { hasAuditScope } from "./has-audit-scope.js";

/**
 * Verifica se o usuário pode visualizar auditorias especiais de aprovação.
 * Perfis Comercial_Opec / Gerente / Financeiro / Master com islist (ou isinsert) veem grupos sensíveis.
 * @param {Object} payload - O payload da auditoria.
 * @param {Set<string>} viewerRoleCodes - Os códigos de papel do usuário.
 * @param {import("../../../../user/model/user-role.type.js").UserRole[]} [viewerRoles]
 * @returns {boolean} Se o usuário pode visualizar auditorias especiais de aprovação.
 */
export function canViewSpecialApprovalAudits(
  payload,
  viewerRoleCodes,
  viewerRoles,
) {
  if (viewerRoleCodes?.has("master") || viewerRoleCodes?.has("admin")) {
    return true;
  }

  const explicitCanViewSpecial = payload?.canViewSpecialApprovalAudits;
  if (typeof explicitCanViewSpecial === "boolean") {
    return explicitCanViewSpecial;
  }

  const explicitCanApproveSpecial = payload?.canApproveSpecialAudit;
  if (typeof explicitCanApproveSpecial === "boolean") {
    return explicitCanApproveSpecial;
  }

  const canApproveNonSensitiveAudit = payload?.canApproveNonSensitiveAudit;
  if (typeof canApproveNonSensitiveAudit === "boolean") {
    return !canApproveNonSensitiveAudit;
  }

  if (Array.isArray(viewerRoles)) {
    if (
      hasAuditScope(viewerRoles, "comercial_opec", "islist") ||
      hasAuditScope(viewerRoles, "comercial_opec", "isinsert") ||
      hasAuditScope(viewerRoles, "gerente_comercial", "islist") ||
      hasAuditScope(viewerRoles, "gerente_comercial", "isinsert") ||
      hasAuditScope(viewerRoles, "financeiro", "islist") ||
      hasAuditScope(viewerRoles, "financeiro", "isinsert") ||
      hasAuditScope(viewerRoles, "master", "islist") ||
      hasAuditScope(viewerRoles, "master", "isinsert")
    ) {
      return true;
    }
  }

  return (
    viewerRoleCodes?.has("comercial_opec") ||
    viewerRoleCodes?.has("gerente_comercial") ||
    viewerRoleCodes?.has("financeiro") ||
    viewerRoleCodes?.has("master") ||
    false
  );
}
